<template>
    <b-container>
        <b-row>
            <h1>Formulários Customizados</h1>
        </b-row>
    </b-container>
</template>

<script>
export default {
    
}
</script>

<style>

</style>